<template>
  <div class="section-light experiences" id="experiences">
    <div class="container">
      <div
        class="columns is-multiline"
        data-aos="fade-in"
        data-aos-easing="linear"
      >
        <div class="column is-12">
          <h1 class="title has-text-centered section-title">{{ $t('message.experiences.head') }}</h1>
        </div>
      </div>
      <div
        class="columns is-multiline is-mobile"
        data-aos="fade-in"
        data-aos-easing="linear"
        style="justify-content: center"
        id="experience-container"
      >
        <div class="column is-narrow" v-for="experience in experience_in_years_with_maximal_size" :key="experience.area">
          <span class="experience-container">
            <span class="experience-dot" :data-experience-area="experience.area" :data-experience-years="experience.years" :data-max-size="experience.maxSize">
              <span class="experience-description">{{ experience.area }}<br>{{ $tc('message.experiences.years', experience.years) }}</span>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inView from 'in-view';
/*

HTML
CSS
Javascript
PHP
MySQL
Java
C++
C#
OracleDB

*/

export default {
  name: 'Experiences',
  data: function() {
    return {experiences: [
      {area: "Java", years: 6},
      {area: "OracleDb", years: 6},
      {area: "HTML", years: 6},
      {area: "Javascript", years: 6},
      {area: "CSS", years: 6},
      {area: "C++", years: 5},
      {area: "PostgreSQL", years: 5},
      {area: "Lucene", years: 4},
      {area: "C#", years: 3},
      {area: "Python", years: 2},
      {area: "PHP", years: 1},
      {area: "MySQL", years: 1},
      {area: "Rust", years: 0},
      {area: "VueJs", years: 0},
      {area: "Redis", years: 0}
    ]};
  },
  computed: {
    experience_in_years() {
      return this.experiences.map(
        function(element) {
          const years = 'years' in element ? element.years : (new Date().getFullYear() - element.since);
          return {"area": element.area, "years": years};
        }
      );
    },
    experience_in_years_with_maximal_size() {
      const min_year = Math.min.apply(Math, this.experience_in_years.map(function(o) { return o.years; }));
      const max_year = Math.max.apply(Math, this.experience_in_years.map(function(o) { return o.years; }));
      const min_size = 120;
      const max_size = 150;
      const year_difference = max_year - min_year;
      const size_difference = max_size - min_size;
      const per_year_size = size_difference / year_difference;
      return this.experience_in_years.map(
        function(element) {
          return {"area": element.area, "years": element.years, "maxSize": min_size + (element.years - min_year) * per_year_size};
        }
      );
    }
  },
  mounted() {
    inView('#experience-container')
    .once('enter', el => {
      console.log(el.id);
      el.querySelectorAll('.experience-dot').forEach(el => {Object.assign(el.style, {width: el.dataset.maxSize + "px", height: el.dataset.maxSize + "px"})});
      el.querySelectorAll('.experience-description').forEach(el => {el.style.opacity = "1.0"});
     });
  }
}
</script>

<style>
.experience-container {
  display: inline-block;
  height: 150px;
  width: 150px;
}

.experience-dot {
  transition: all 2s;
  transition-property: width, height;
  width: 0px;
  height: 0px;
  font-size: large;
  text-align: center;
  background-color: #4c567b;
  border-radius: 50%;
  display: table-cell;
  color: white;
  vertical-align: middle;
}

.experience-description {
  opacity: 0;
  transition: opacity 6s;
}
</style>
